// This file configures the initialization of Sentry on the client.
;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"7mWXB0ynGrrJTRpBSC9ja"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN || process.env.SENTRY_DSN;
const SENTRY_ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT || process.env.ENVIRONMENT || "production";
// The Sentry account only carries the production environment.
const IS_PRODUCTION = /^prod(uction)?$/i.test(SENTRY_ENVIRONMENT);

Sentry.init({
  dsn: SENTRY_DSN,
  enabled: !!SENTRY_DSN && IS_PRODUCTION,
  environment: SENTRY_ENVIRONMENT,

  integrations: [Sentry.replayIntegration(), Sentry.browserTracingIntegration()],

  tracesSampleRate: Number(process.env.SENTRY_TRACE_SAMPLE_RATE ?? 0.1) || 0.1,
  profilesSampleRate: Number(process.env.SENTRY_PROFILE_SAMPLE_RATE ?? 0.1) || 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  debug: false,
});
